/**
 * P3-38: TimeTab —— Time 标签页根组件。
 *
 * 对齐 `js/time.js:1963-2028`：
 * - Time 面板（flux/heat + 加速按钮）
 * - Reset 面板
 * - Chronoforge 面板（条件显示）
 * - VoidSpace 面板（条件显示）
 */
import { SpacePanel } from "../space/SpacePanel";
import ChronoforgeWgt from "./ChronoforgeWgt";
import ResetWgt from "./ResetWgt";
import TimeControlWgt from "./TimeControlWgt";
import VoidSpaceWgt from "./VoidSpaceWgt";

export default function TimeTab() {
  return (
    <div className="tabInner Time">
      <SpacePanel title="tab.name.time">
        <TimeControlWgt />
      </SpacePanel>

      <SpacePanel title="menu.reset">
        <ResetWgt />
      </SpacePanel>

      <ChronoforgeWgt />
      <VoidSpaceWgt />
    </div>
  );
}
